import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { borderShape, getColor, getSpace } from '@stylesheets/tools';
import track from '@helper/tracking';

const StyledItemWrapper = styled.div`
  padding: 21px ${getSpace('xs')} ${getSpace('xs')} ${getSpace('xs')};
  overflow: hidden;
  display: block;
  position: relative;

  &:before {
    position: absolute;
    content: '';
    inset: 0;
    width: 100%;
    z-index: 1;
    transform: scale(-1, 1);
    overflow: hidden;
    background: ${getColor('white')};
    clip-path: polygon(10px 0, 100% 0, 100% 100%, 0 100%, 0 10px);
    ${props => borderShape(props.$borderColor || 'black')}
  }

  & > div {
    position: relative;
    z-index: 1;
  }

  h3 {
    margin-bottom: ${getSpace('xxxxs')};
  }

  p {
    margin: 0;
    color: ${getColor('teaserGray')};
  }
`;

const ItemWrapper = ({ children, borderColor = 'black', href, target, rel }) => {
  return (
    <StyledItemWrapper
      $borderColor={borderColor}
      as={href ? 'a' : 'div'}
      href={href}
      target={target}
      rel={rel}
      onClick={() => {
        const pathWithoutQueryParams = new URL(href, window.location.origin).pathname;
        track(['trackEvent', 'Archive', 'Article', pathWithoutQueryParams]);
      }}
    >
      <div>{children}</div>
    </StyledItemWrapper>
  );
};

ItemWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  borderColor: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string
};

export default ItemWrapper;
